import { NotifyHelper } from "../../../helpers/toast";
import { objHocSinhAceChiTietDefine } from "../../action-types/hoc-sinh/IHocSinhAceChiTietActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const hocSinhAceChiTietActions = {
    ...generateActions(objHocSinhAceChiTietDefine, "HOC_SINH_ACE_CHI_TIET"),
    ...generateActionForKey(objHocSinhAceChiTietDefine, "HOC_SINH_ACE_CHI_TIET",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objHocSinhAceChiTietDefine, "HOC_SINH_ACE_CHI_TIET",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objHocSinhAceChiTietDefine, "HOC_SINH_ACE_CHI_TIET",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objHocSinhAceChiTietDefine, "HOC_SINH_ACE_CHI_TIET",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objHocSinhAceChiTietDefine, "HOC_SINH_ACE_CHI_TIET",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
